import { Slugs } from "../slug.loader";
import { getAsyncValidator, getValidityState } from "./baseValidator";
const EMAIL_FORMAT = /^((?!\.)[\w\-.+]*[^.,-])(@[a-zA-Z0-9]+)([.-][a-zA-Z0-9]+)*([.][a-zA-Z0-9]+)$/;
export function getEmailValidityState(email) {
    if (isEmailTooLong(email) || !isEmailFormatValid(email)) {
        return getValidityState(Slugs.translated.invalidEmailFormat);
    }
    return getValidityState();
}
export const getEmailValidityStateAsync = getAsyncValidator(getEmailValidityState);
function isEmailFormatValid(email) {
    return EMAIL_FORMAT.test(email);
}
function isEmailTooLong(email) {
    const [localPart] = email.split("@");
    return localPart.length > 64;
}
